import { BenefitsCard } from 'sections/Home/types';

export const DefaultMetaData = {
  title: 'Global Freight Forwarder Network & NVOCCs Platform | DF Alliance',
  description: 'DF Alliance is the trusted network for freight forwarders and NVOCCs. Join our global network to grow your logistics business through strategic partnerships.',
};

// Blacklist of pages where membership banner in modal window should not appear on:
export const blacklistForMembershipBanner: Array<string> = [
  '/membership',
  '/auth/sign-up',
  '/auth/sign-in',
  '/auth/forgot-password',
  '/auth/confirm-password',
  '/partners/erp-enquiry',
];

export const benefitsCards: BenefitsCard[] = [
  // Logistics Explorer
  {
    id: 1,
    icon: 'icon-logistics-explorer.svg',
    title: 'Logistics Explorer',
    description: 'The best sea freight calculator for your website.',
    link: 'https://www.searates.com/integrations/logistics-explorer',
    alt: 'Logistics Explorer',
    className: null,
  },
  // Tracking System
  {
    id: 2,
    icon: 'icon-tracking-system.svg',
    title: 'Tracking System',
    description: 'The ultimate cargo tracking tool that works on any desktop or mobile device.',
    link: '/digital-tools/tracking-system',
    alt: 'Tracking System',
    className: null,
  },
  // Shipping Leads
  {
    id: 3,
    icon: 'icon-shipping-leads.svg',
    title: 'Shipping Leads',
    description: 'Tap into a global network of logistics opportunities. Receive instant shipping requests, bid on them directly, and connect with businesses seeking your services—anytime, anywhere.',
    link: '/benefits/shipping-leads',
    alt: 'Shipping Leads',
    className: 'shipping-leads',
  },
  // Ship Schedules
  {
    id: 4,
    icon: 'icon-ship-schedules.svg',
    title: 'Ship Schedules',
    description: 'We allow you to check shipping schedules by routing, by port, by vessel, or by carrier.',
    link: 'https://www.searates.com/services/schedules',
    alt: 'Ship Schedules',
    className: null,
  },
  // SeaRates ERP Tool
  {
    id: 5,
    icon: 'icon-searates-erp.svg',
    title: 'SeaRates ERP Tool',
    description: 'A highly cost-effective and fully integrated Freight management software solution for all Freight Forwarders.',
    link: '/digital-tools/searates-erp',
    alt: 'SeaRates ERP Tool',
    className: null,
  },
  // Payment Protection
  {
    id: 6,
    icon: 'icon-payment-protection.svg',
    title: 'Payment Protection',
    description: 'DFA members are automatically covered by a best in class credit risk insurance. The insurance starts at US$ 10,000 up to US $100,000 per year.',
    link: '/benefits/payment-protection',
    alt: 'Payment Protection',
    className: null,
  },
];
